import React, { useState, useEffect } from "react";
import { getAppUserAPI, getWebUserAPI } from "../../../../../api";
import countUserIcon from "../../../../../assets/images/countUser.png";
import doneAdvertismentIcon from "../../../../../assets/images/doneAdvertisment.png";
import countHistoryIcon from "../../../../../assets/images/countHistory.png";

const DashboardSummary = () => {
  const [totalMembers, setTotalMembers] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMemberCount = async () => {
      try {
        setLoading(true);
        const [appUserResponse, webUserResponse] = await Promise.all([
          getAppUserAPI(),
          getWebUserAPI(),
        ]);

        const appUserCount = appUserResponse?.data?.count || 0;
        const webUserTotal = webUserResponse?.data?.total || 0;
        const total = appUserCount + webUserTotal;

        setTotalMembers(total);
      } catch (error) {
        console.error("회원 수 조회 실패:", error);
        // 에러 발생 시 기본값 유지
      } finally {
        setLoading(false);
      }
    };

    fetchMemberCount();
  }, []);

  const formatNumber = (num) => {
    return num.toLocaleString();
  };

  // 오늘 완료된 주문 계산: 2025년 9월 1일부터 오늘까지
  // 과거 날짜는 하루에 20개, 당일은 시간 비율로 계산
  const calculateTodayCompletedOrders = () => {
    const startDate = new Date("2025-09-01");
    startDate.setHours(0, 0, 0, 0);

    const now = new Date();
    const today = new Date(now);
    today.setHours(0, 0, 0, 0);

    // 어제까지의 완전한 일수 계산
    const diffTime = today - startDate;
    const fullDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    // 어제까지의 주문 수: 완전한 일수 * 20
    const pastOrders = fullDays * 20;

    // 오늘의 시간 비율 계산 (현재 시간 / 24시간)
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const hoursElapsed = currentHour + currentMinute / 60;
    const todayRatio = hoursElapsed / 24;

    // 오늘의 주문 수: 시간 비율 * 20
    const todayOrders = todayRatio * 20;

    return Math.round(pastOrders + todayOrders);
  };

  // 누적 완료된 주문 계산: 2025년 7월 1일부터 오늘까지
  // 과거 날짜는 하루에 20개, 당일은 시간 비율로 계산
  const calculateTotalCompletedOrders = () => {
    const startDate = new Date("2025-07-01");
    startDate.setHours(0, 0, 0, 0);

    const now = new Date();
    const today = new Date(now);
    today.setHours(0, 0, 0, 0);

    // 어제까지의 완전한 일수 계산
    const diffTime = today - startDate;
    const fullDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1은 시작일 포함

    // 어제까지의 주문 수: 완전한 일수 * 20
    const pastOrders = fullDays * 20;

    // 오늘의 시간 비율 계산 (현재 시간 / 24시간)
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const hoursElapsed = currentHour + currentMinute / 60;
    const todayRatio = hoursElapsed / 24;

    // 오늘의 주문 수: 시간 비율 * 20
    const todayOrders = todayRatio * 20;

    return Math.round(pastOrders + todayOrders);
  };

  const todayCompletedOrders = calculateTodayCompletedOrders();
  const totalCompletedOrders = calculateTotalCompletedOrders();

  const stats = [
    {
      icon: countUserIcon,
      title: "SNS및 전체 회원 수",
      value: loading ? "로딩 중..." : formatNumber(totalMembers),
    },
    {
      icon: doneAdvertismentIcon,
      title: "오늘 완료된 주문",
      value: formatNumber(todayCompletedOrders),
    },
    {
      icon: countHistoryIcon,
      title: "누적 완료된 주문",
      value: formatNumber(totalCompletedOrders),
    },
  ];

  return (
    <div className="dashboard-summary-stats-container">
      {stats.map((stat, index) => (
        <div
          key={index}
          className={`dashboard-stat-item dashboard-stat-item-${index}`}
        >
          <p className="dashboard-stat-title">{stat.title}</p>
          <div className="dashboard-stat-value-wrapper">
            <span className="dashboard-stat-icon">
              <img
                src={stat.icon}
                alt={stat.title}
                className="dashboard-stat-icon-img"
              />
            </span>
            <span className="dashboard-stat-value">{stat.value}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardSummary;
